<div [class]="question.cssClasses.noRowsSection">
  <div [class]="question.cssClasses.noRowsText">
    <sv-ng-string [model]="question.locNoRowsText"></sv-ng-string>
  </div>
  <button
    *ngIf="question.renderedTable.showAddRow"
    type="button"
    [class]="question.getAddRowButtonCss(true)"
    (click)="addRowClick()"
  >
    <sv-ng-string [model]="question.locAddRowText"></sv-ng-string>
    <span [class]="question.cssClasses.iconAdd"></span>
  </button>
</div> 